// extracted by mini-css-extract-plugin
export default {"InputBox":"InputBox_InputBox__Oaih6"};